import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';
import store from '../../store';

const success = ({ data }, resolve) => {
  const purchase = purchaseTransformer.fetch(data);
  resolve(purchase);

  store.dispatch('RefreshStockProductsCustom');
  store.dispatch('fetchCurrentPurchase', purchase);
  store.dispatch('allCurrentStockProductsCustom', purchase.products);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/purchases/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/show.js